// src/components/CadeteMap.js
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polygon, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// Importação necessária para formatar a data e comparar datas
import { formatarData, getNormalizedDateString } from '../utils/helpers';

// Correção de ícones do Leaflet no React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// --- Definição dos Ícones Personalizados (CORRIGIDO PARA USO DE ARQUIVOS LOCAIS) ---

// NOVO: Usa process.env.PUBLIC_URL para apontar para a pasta public/
const PUBLIC_URL = `${process.env.PUBLIC_URL}`;

// Ícone Azul (Padrão / Agendado)
const blueIcon = new L.Icon({
  // ALTERAÇÃO: Aponta para o arquivo na pasta public
  iconUrl: `${PUBLIC_URL}/marker-icon-blue.png`, 
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Ícone Cinza (Realizado / Passado)
const greyIcon = new L.Icon({
  // ALTERAÇÃO: Aponta para o arquivo na pasta public
  iconUrl: `${PUBLIC_URL}/marker-icon-grey.png`, 
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const CadeteMap = ({ locais }) => {
  const [kmlPolygons, setKmlPolygons] = useState([]);
  const [center, setCenter] = useState([-23.55052, -46.633309]); // SP Centro

  useEffect(() => {
    // Carrega o KML da pasta public
    fetch('/mapa.kml')
      .then(response => response.text())
      .then(text => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, "text/xml");
        const placemarks = xmlDoc.getElementsByTagName("Placemark");
        const polys = [];

        for (let i = 0; i < placemarks.length; i++) {
          const placemark = placemarks[i];
          const name = placemark.getElementsByTagName("name")[0]?.textContent || "Sem Nome";
          const polygon = placemark.getElementsByTagName("Polygon")[0];
          
          if (polygon) {
            const coordinatesRaw = polygon.getElementsByTagName("coordinates")[0]?.textContent;
            if (coordinatesRaw) {
              const coords = coordinatesRaw.trim().split(/\s+/).map(coord => {
                const parts = coord.split(',');
                if (parts.length >= 2) {
                    // KML é Longitude, Latitude. Leaflet é Latitude, Longitude.
                    return [parseFloat(parts[1]), parseFloat(parts[0])];
                }
                return null;
              }).filter(c => c !== null);
              
              // Define cores baseadas no nome (Ex: CPA, BPM)
              let color = '#3388ff'; // Azul padrão
              if (name.includes('CPA')) color = '#ff3333'; // Vermelho
              if (name.includes('BPM')) color = '#33ff33'; // Verde

              polys.push({ name, positions: coords, color });
            }
          }
        }
        setKmlPolygons(polys);
      })
      .catch(err => console.error("Erro ao carregar KML:", err));
  }, []);

  // Foca no primeiro local da lista se houver
  useEffect(() => {
    if (locais && locais.length > 0) {
        const primeiro = locais[0];
        if (primeiro.latitude && primeiro.longitude) {
            setCenter([parseFloat(primeiro.latitude), parseFloat(primeiro.longitude)]);
        }
    }
  }, [locais]);

  const RecenterMap = ({ center }) => {
    const map = useMap();
    useEffect(() => {
        map.flyTo(center, 12);
    }, [center, map]);
    return null;
  };

  return (
    <div className="h-96 w-full border rounded-lg overflow-hidden shadow-lg relative z-0">
      <MapContainer center={center} zoom={11} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <RecenterMap center={center} />

        {/* Polígonos do KML */}
        {kmlPolygons.map((poly, idx) => (
          <Polygon 
            key={idx} 
            positions={poly.positions} 
            pathOptions={{ color: poly.color, weight: 2, fillOpacity: 0.1 }}
          >
            <Popup>{poly.name}</Popup>
          </Polygon>
        ))}

        {/* Marcadores dos Locais */}
        {locais.filter(l => l.latitude && l.longitude).map((local, index) => {
           // Lógica de cor (Passado vs Futuro)
           const hojeStr = getNormalizedDateString(new Date());
           const dataEstagioStr = local.data_escolha ? getNormalizedDateString(local.data_escolha) : '';
           const isRealizado = dataEstagioStr && dataEstagioStr < hojeStr;
           const iconToUse = isRealizado ? greyIcon : blueIcon;

           return (
            <Marker 
                key={`${local.id}-${index}`} 
                position={[parseFloat(local.latitude), parseFloat(local.longitude)]}
                icon={iconToUse} 
            >
                <Popup>
                    <strong>{local.nome}</strong><br/>
                    <span className="text-gray-600 text-sm">{local.tipo}</span><br/>
                    
                    {/* --- ATUALIZAÇÃO: Exibe LISTA de Cadetes --- */}
                    {local.cadetes && local.cadetes.length > 0 && (
                        <div className="mt-2 mb-2 pt-2 border-t border-gray-200">
                            <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider">
                                Cadetes ({local.cadetes.length}):
                            </span>
                            <ul className="text-sm text-gray-900 bg-gray-50 p-1 rounded border border-gray-100 list-disc pl-4 mt-1">
                                {local.cadetes.sort().map((nome, i) => (
                                    <li key={i} className="font-bold">{nome}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    
                    {/* Fallback para caso venha só um nome (compatibilidade com dashboard de cadete) */}
                    {local.cadete_nome && !local.cadetes && (
                        <div className="mt-2 mb-2 pt-2 border-t border-gray-200">
                            <span className="text-[10px] text-gray-500 uppercase font-bold tracking-wider">
                                Cadete:
                            </span>
                            <div className="text-sm font-extrabold text-gray-900 bg-gray-50 p-1 rounded border border-gray-100">
                                {local.cadete_nome}
                            </div>
                        </div>
                    )}
                    {/* ------------------------------------------- */}

                    <div className="mt-2 pt-2 border-t border-gray-200">
                        {isRealizado ? (
                            <span className="text-gray-500 font-bold block text-xs uppercase mb-1 flex items-center gap-1">
                                <span className="w-2 h-2 bg-gray-500 rounded-full inline-block"></span> REALIZADO
                            </span>
                        ) : (
                            <span className="text-blue-600 font-bold block text-xs uppercase mb-1 flex items-center gap-1">
                                <span className="w-2 h-2 bg-blue-600 rounded-full inline-block"></span> AGENDADO
                            </span>
                        )}
                        <span className="text-gray-800 text-sm font-semibold">
                            Data: {formatarData(local.data_escolha)}
                        </span>
                    </div>
                </Popup>
            </Marker>
           );
        })}
      </MapContainer>
    </div>
  );
};

export default CadeteMap;